import type { Ref } from "react"

type Props = {
  value: string
  onChange: (value: string) => void
  placeholder?: string
  ariaLabel?: string
  autoFocus?: boolean
  inputRef?: Ref<HTMLInputElement>
  /** Escape в поле — закрыть меню; stopPropagation, чтобы Escape не улетел в родительский диалог. */
  onDismiss: () => void
  /** Enter — выбрать первый видимый пункт. */
  onCommitFirst?: () => void
}

/**
 * Единая строка поиска в выпадающих меню (SelectDropdown, CheckboxSelectDropdown,
 * ScopeSwitcher): один вид инпута и одно поведение клавиатуры во всех меню.
 * В ul-меню оборачивать в `<li role="none" className="sticky top-0 z-10">`.
 */
export function DropdownSearchInput({
  value,
  onChange,
  placeholder,
  ariaLabel,
  autoFocus = false,
  inputRef,
  onDismiss,
  onCommitFirst,
}: Props) {
  return (
    <div className="border-b border-ui-border bg-ui-bg-elevated p-1.5">
      <input
        ref={inputRef}
        type="text"
        value={value}
        placeholder={placeholder}
        aria-label={ariaLabel ?? placeholder}
        autoFocus={autoFocus}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === "Escape") {
            e.stopPropagation()
            onDismiss()
            return
          }
          if (e.key === "Enter") {
            e.preventDefault()
            onCommitFirst?.()
          }
        }}
        className="h-7 w-full rounded-md border border-ui-border bg-ui-surface-sunken px-2 text-xs text-ui-text-primary placeholder:text-ui-text-muted focus:outline-none focus-visible:ring-2 focus-visible:ring-[var(--ui-focus-ring)]"
      />
    </div>
  )
}
